<p-dialog [visible]="true" [draggable]="false" [modal]="true" resizable="true" [contentStyle]="{'overflow': 'visible'}">
	<ng-template pTemplate="header">{{'h5.transportmodal.name' | translate}}</ng-template>

	<div class="dialog-body">

		<form [formGroup]="formGroup">
			<p-select
				[options]="modals"
				optionLabel="transportModalX"
				formControlName="transportModal"
				optionValue="transportModalC">
			</p-select>
		</form>
	</div>
	<ng-template pTemplate="footer">
		<span>
			<button (click)="closeModal()"
				  id="closeExportChooseModal"
				  type="button" pButton
				  label="{{'modal.cancel' | translate}}"
				  class="cancel-button">

			</button>
			<button id="confirmExportChooseModal"
				  (click)="confirmModal()" pButton
				  label="{{'button.commercialInvoice' | translate}}"
				  [disabled]="!formGroup.valid"
				  class="confirm-button"></button>
		</span>
	</ng-template>
</p-dialog>
